import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M180-674v494h600v-494H640v293q0 18-14 26t-29 1l-117-58-117 58q-15 8-29-1t-14-26v-293H180Zm0 554q-25 0-42-18-18-17-18-42v-529q0-10 3-19t9-17l52-71q8-11 21-17 13-7 27-7h495q14 0 27 7t21 17l53 71q6 8 9 17t3 19v529q0 25-18 42-17 18-42 18H180Zm17-614h565l-36-46H233l-36 46Zm183 60v245l100-50 100 50v-245H380Zm-200 0h600-600Z"/>',
  f: '<path d="M180-120q-25 0-42-18-18-17-18-42v-529q0-10 3-19t9-17l52-71q8-11 21-17 13-7 27-7h495q14 0 27 7t21 17l53 71q6 8 9 17t3 19v529q0 25-18 42-17 18-42 18H180Zm17-614h565l-36-46H233l-36 46Zm443 60H320v293q0 18 14 26t29 1l117-58 117 58q15 8 29-1t14-26v-293Z"/>',
};

export default data;
